import axios from "axios"
import { toast } from "react-toastify"
import { BACKEND } from "../../config/configEnvs"

export default async function ActualizarFechaInicioProyecto({serviceId}) {
  try {
    if (!serviceId) {
      toast.error("No se encontró el servicio")
      return
    }

    const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`)
    const service = response.data

    if (service.servicio.categoria === "Web") {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`, {
        fechaInicio: new Date().toISOString()
      })
      toast.success("Fecha de inicio actualizada correctamente")
    }

  } catch (error) {
    toast.error("Error al actualizar la fecha de inicio del servicio: " + error)
  }
}